const oop = ace.require('ace/lib/oop');
const PythonHighlightRules = ace.require('ace/mode/python_highlight_rules').PythonHighlightRules;
const PythonMode = ace.require('ace/mode/python').Mode;

export class NotebookHighlightService {
  public highlightSecrets(editor, secrets: Array<string>) {
    const highlightRules = this.createCustomPythonHighlightRules(secrets);

    const CustomPythonMode = function () {
      PythonMode.call(this);
      this.HighlightRules = highlightRules;
    };

    oop.inherits(CustomPythonMode, PythonMode);
    editor.getSession().setMode(new CustomPythonMode());
  }

  private createCustomPythonHighlightRules(highlightKeywords: Array<string>) {
    const CustomPythonHighlightRules = function () {
      PythonHighlightRules.call(this);
      if (highlightKeywords && highlightKeywords.length) {
        const keywordMapper = this.createKeywordMapper(
          {
            mode_secret: highlightKeywords.join('|'),
          },
          'identifier',
          true
        );
        this.$rules.start = [
          {
            token: keywordMapper,
            regex: '\\b(?:' + highlightKeywords.join('|') + ')\\b',
          },
          ...this.$rules['start'],
        ];
      }
      this.normalizeRules();
    };
    oop.inherits(CustomPythonHighlightRules, PythonHighlightRules);
    return CustomPythonHighlightRules;
  }
}
